import { toast } from 'react-toastify';

import { signOut } from '~/store/modules/auth/actions';

import { getCommunityErrorMessage } from './communityUtils';

export default function handleCommunityError(error, dispatch, fallback) {
  const status = error && error.response && error.response.status;

  toast.error(getCommunityErrorMessage(error, fallback));

  if (status === 401) dispatch(signOut());
}

